/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Identifier for subscription process steps.
 * These codes are used as i18n translation keys on the frontend (e.g., COMMON.LABELS.FOLDER_CREATION).
 * 
 * ## Main Steps (all branches)
 * - FOLDER_CREATION: Main step grouping registration sub-steps
 * - PRICING: Pricing/quotation step
 * - CONTRACTUALIZATION: Contract generation and signing step
 * - SIGNED_CONTRACT: Final step when contract is signed
 * 
 * ## Sub-Steps - Folder Creation
 * - REGISTRATION: Actor/Person registration
 * - REAL_ESTATE_REGISTRATION: Real estate property registration (UPI, RGI)
 * - TENANT_REGISTRATION: Tenant registration (RGI only)
 * - COPROPERTY_REGISTRATION: Coproperty registration (MRI only)
 * - COPROPERTY_SURVEY: Coproperty risk-appreciation survey COPRO_MRI (MRI only)
 * - COPROPERTY_BUILDINGS: Coproperty buildings loop (MRI only) — revealed once the survey verdict is eligible
 * - COPROPERTY_COMPLEMENTS: Coproperty complements (current contract, next general meeting, claims history — MRI only), passable, never blocking
 * - PROFILING: Risk profiling questionnaire (Unemployment)
 * - ELIGIBILITY: Eligibility check on cumulative revenue (Legal protection only)
 * 
 * ## Borrower-specific Steps
 * - PROJECT: Borrower project configuration (insureds, loans)
 * 
 * ## Branch-specific Step Combinations
 * 
 * ### Unemployment (Chômage)
 * 1. FOLDER_CREATION
 *    - REGISTRATION
 *    - PROFILING
 * 2. PRICING
 * 3. CONTRACTUALIZATION
 * 4. SIGNED_CONTRACT
 * 
 * ### UPI (CBNO - Copropriété)
 * 1. FOLDER_CREATION
 *    - REGISTRATION
 *    - REAL_ESTATE_REGISTRATION
 * 2. PRICING
 * 3. CONTRACTUALIZATION
 * 4. SIGNED_CONTRACT
 * 
 * ### RGI (GLI - Garantie Loyers Impayés)
 * 1. FOLDER_CREATION
 *    - REGISTRATION
 *    - REAL_ESTATE_REGISTRATION
 *    - TENANT_REGISTRATION
 * 2. PRICING
 * 3. CONTRACTUALIZATION
 * 4. SIGNED_CONTRACT
 * 
 * ### MRI (Multirisque Immeuble)
 * 1. FOLDER_CREATION
 *    - REGISTRATION
 *    - COPROPERTY_REGISTRATION
 *    - COPROPERTY_SURVEY
 *    - COPROPERTY_BUILDINGS
 *    - COPROPERTY_COMPLEMENTS
 * 2. PRICING
 * 3. CONTRACTUALIZATION
 * 4. SIGNED_CONTRACT
 * 
 * ### Legal protection (Protection juridique)
 * 1. FOLDER_CREATION
 *    - REGISTRATION
 *    - ELIGIBILITY
 * 2. PRICING
 * 3. CONTRACTUALIZATION
 * 4. SIGNED_CONTRACT
 * 
 * ### Borrower (Emprunteur)
 * 1. PROJECT
 * 2. PRICING
 * 3. CONTRACTUALIZATION
 * 4. SIGNED_CONTRACT
 * 
 * @export
 */
export const StepIdentifier = {
    FolderCreation: 'FOLDER_CREATION',
    Pricing: 'PRICING',
    Contractualization: 'CONTRACTUALIZATION',
    SignedContract: 'SIGNED_CONTRACT',
    Registration: 'REGISTRATION',
    RealEstateRegistration: 'REAL_ESTATE_REGISTRATION',
    TenantRegistration: 'TENANT_REGISTRATION',
    CopropertyRegistration: 'COPROPERTY_REGISTRATION',
    CopropertySurvey: 'COPROPERTY_SURVEY',
    CopropertyBuildings: 'COPROPERTY_BUILDINGS',
    CopropertyComplements: 'COPROPERTY_COMPLEMENTS',
    Profiling: 'PROFILING',
    Eligibility: 'ELIGIBILITY',
    Project: 'PROJECT'
} as const;
export type StepIdentifier = typeof StepIdentifier[keyof typeof StepIdentifier];


export function instanceOfStepIdentifier(value: any): boolean {
    for (const key in StepIdentifier) {
        if (Object.prototype.hasOwnProperty.call(StepIdentifier, key)) {
            if (StepIdentifier[key as keyof typeof StepIdentifier] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StepIdentifierFromJSON(json: any): StepIdentifier {
    return StepIdentifierFromJSONTyped(json, false);
}

export function StepIdentifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): StepIdentifier {
    return json as StepIdentifier;
}

export function StepIdentifierToJSON(value?: StepIdentifier | null): any {
    return value as any;
}

export function StepIdentifierToJSONTyped(value: any, ignoreDiscriminator: boolean): StepIdentifier {
    return value as StepIdentifier;
}

